import * as ReduxToolkit from "@reduxjs/toolkit";
import { DriversMenuRow, DriversRow } from "../../api";

export interface DriverMenuState {
    selectedOfficeId: number | null;
    selectedDriver: DriversRow | null;
    selectedPlanType: string | null;
    results: DriversMenuRow[] | null;
}

export const initDriverMenuState = (): DriverMenuState => {
    return {
        selectedDriver: null,
        selectedOfficeId: null,
        selectedPlanType: null,
        results: null,
    } as DriverMenuState;
};

export const driverMenuSlice = ReduxToolkit.createSlice({
    name: "driver_menu_slice",
    initialState: initDriverMenuState() as DriverMenuState,
    reducers: {
        resetState: (state) => {
            state = initDriverMenuState();
            return state;
        },
        setSelectedDriver: (
            state,
            action: ReduxToolkit.PayloadAction<DriversRow | null>
        ) => {
            state.selectedDriver = action.payload;
            return state;
        },
        setCondition: (
            state,
            action: ReduxToolkit.PayloadAction<[number | null, string | null]>
        ) => {
            state.selectedOfficeId = action.payload[0];
            state.selectedPlanType = action.payload[1];
            return state;
        },
        setSelectedOfficeId: (
            state,
            action: ReduxToolkit.PayloadAction<number | null>
        ) => {
            state.selectedOfficeId = action.payload;
            return state;
        },
        selectedPlanType: (
            state,
            action: ReduxToolkit.PayloadAction<string | null>
        ) => {
            state.selectedPlanType = action.payload;
            return state;
        },
        setResults: (
            state,
            action: ReduxToolkit.PayloadAction<DriversMenuRow[] | null>
        ) => {
            state.results = action.payload;
            return state;
        },
    },
});
